import React, { useState, useEffect } from "react";
import { ReactComponent as AnimatedLogo } from "../../assets/sastiride-logo-animated.svg";
import "./splashScreen.css";

const SplashScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade-out after animation finishes (~3s)
    const fadeTimer = setTimeout(() => setFadeOut(true), 3200);
    // Remove splash after fade-out transition ends
    const removeTimer = setTimeout(() => onComplete(), 3700);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [onComplete]);

  return (
    <div className={`splash-screen${fadeOut ? " splash-screen--fade-out" : ""}`}>
      <div className="splash-screen__logo">
        <AnimatedLogo />
      </div>
    </div>
  );
};

export default SplashScreen;
